import { render } from "./NcrmMailjetUnlinkedEmailsList.vue?vue&type=template&id=528518ba&scoped=true"
import script from "./NcrmMailjetUnlinkedEmailsList.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetUnlinkedEmailsList.vue?vue&type=script&lang=js"

import "./NcrmMailjetUnlinkedEmailsList.vue?vue&type=style&index=0&id=528518ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528518ba"]])

export default __exports__